export default __webpack_public_path__ + "static/media/no-adverts.50afadac.png";